// Official Hérisson sous gazon logo (image asset)
import React from "react";
import logoUrl from "@/assets/herisson-logo.webp";

// Size preset heights (px) — the image auto-scales width.
const SIZES = { xs: 36, sm: 56, md: 100, lg: 150, xl: 220 };

export default function HerissonLogo({ size = "lg", className = "", style = {} }) {
  const h = SIZES[size] || SIZES.lg;
  return (
    <img
      src={logoUrl}
      alt="Hérisson sous gazon"
      height={h}
      style={{ height: h, width: "auto", display: "block", ...style }}
      className={className}
      draggable={false}
    />
  );
}
